module.exports = __webpack_public_path__ + "static/media/ic-fix-temp.dfa01ecd.svg";